import { loadAsyncJsLib } from '@/utils/async';
import { SocialLoginProvider } from '@/plugins/social-login/SocialLoginProvider';

export class GoogleProvider extends SocialLoginProvider {
  async install() {
    await loadAsyncJsLib('https://accounts.google.com/gsi/client', { crossOrigin: null });

    // O id_token (credential JWT) chega de forma assíncrona pelo callback do GIS,
    // disparado pelo clique no botão renderizado. Quem trata o credential é o
    // consumidor que se registrar via onCredential().
    this._onCredential = null;

    window.google.accounts.id.initialize({
      client_id: this.clientId,
      callback: (response) => {
        if (response?.credential) {
          this._onCredential?.(response.credential);
        }
      },
    });
  }

  // Renderiza o botão oficial do Google no elemento. O clique abre o seletor de
  // conta (funciona no WebKit/iOS, diferente do One Tap, que é suprimido lá) e
  // dispara o callback do initialize com o credential.
  renderButton(element, options = {}) {
    window.google.accounts.id.renderButton(element, {
      type: 'icon',
      shape: 'circle',
      theme: 'outline',
      size: 'large',
      ...options,
    });
  }

  onCredential(handler) {
    this._onCredential = handler;
  }

  async logout() {
    window.google?.accounts?.id?.disableAutoSelect();
  }

  get name() {
    return 'google';
  }

  get icon() {
    return require('@/assets/icons/google.svg');
  }

  isActive () {
    return true;
  }
}
